import React, { Component } from 'react';
export default  class Resume extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="resume">

         <div className="row education">

            <div className="three columns header-col">
               <h1><span>Education</span></h1>
            </div>

            <div className="nine columns main-col">
              
                  
                    <div className="row item">
                       <div className="twelve columns">
                          <h3>No university!!!</h3>
                          <p className="info">
                          specialialize in programming
                          <span>&bull;</span> <em className="date">2018</em></p>
                          <p>
                          the journey has been fun and exciting looking foward to the next years, hope iI will learn even more.
                          </p>
                       </div>
                    </div>
                  
                
              
            </div>
         </div>
        <div className="row work">
            <div className="three columns header-col">
               <h1><span>Work</span></h1>
            </div>

            <div className="nine columns main-col">
              
                    <div className="row item">
                       <div className="twelve columns">
                          <h3>Smaller Sites</h3>
                          <p className="info">
                          react developer
                          <span>&bull;</span> <em className="date">2020</em></p>
                          <p>
                          learnt about other javascript frameworks, learn how to use material -ui and firebase!
                          </p>
                       </div>

                    </div>

                  
            </div> 
         </div>


         <div className="row skill">

            <div className="three columns header-col">
               <h1><span>Skills</span></h1>
            </div>

            <div className="nine columns main-col">

               <p>
               #React js <br/>
               #React native (intermediate)<br/>
               #Html<br/>
               #css<br/>
               #javascript<br/>
               #nodejs(beginner)<br/>
               #express js(beginner) <br/>
               </p>


   			</div>

         </div>

      </section>
    );
  }
}